// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\GuestPriceResponse

import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type GuestPriceApiResponse = {
	id: string;
	name: string;
	description: string;
	price: number;
	minPax: number;
	maxPax: number;
	validMinPax: number;
	validMaxPax: number;
	archivedAt: string | null;
};

export type GuestPrice = {
	id: string;
	name: string;
	description: string;
	price: number;
	minPax: number;
	maxPax: number;
	validMinPax: number;
	validMaxPax: number;
	archivedAt: DateTime | null;
};

export function hydrateGuestPrice(data: GuestPriceApiResponse): GuestPrice {
	return {
		...data,
		archivedAt: DateTimefromISO(data.archivedAt),
	};
}